export type NudgeDueCountdown = { kind: "overdue"; days: number } | { kind: "today" } | { kind: "days"; days: number };

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function toNudgeDueCountdown(dueDate: string | undefined, keepsAdmitting: boolean, now: Date): NudgeDueCountdown | undefined {
    if (!dueDate || keepsAdmitting) {
        return undefined;
    }

    const due = Date.parse(`${dueDate}T00:00:00.000Z`);

    if (Number.isNaN(due)) {
        return undefined;
    }

    const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
    const days = Math.round((due - today) / MS_PER_DAY);

    if (days < 0) {
        return { kind: "overdue", days: -days };
    }

    return days === 0 ? { kind: "today" } : { kind: "days", days };
}
